<div class="min-vh-100 bg-light">
  <app-header [page]="'Support'"></app-header>

  <main class="container py-4">

    <div class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="fw-bold mb-0">My Tickets</h4>
      <a routerLink="/support" class="btn btn-outline-secondary btn-sm">
        Help Center
      </a>
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-body">

        <div *ngIf="loading" class="text-center py-4">
          <div class="spinner-border spinner-border-sm"></div>
        </div>

        <div *ngIf="!loading && !tickets.length" class="text-muted text-center py-4">
          No support tickets yet.
        </div>

        <div *ngIf="tickets.length" class="table-responsive">
          <table class="table align-middle">
            <thead>
              <tr>
                <th>Subject</th>
                <th>Category</th>
                <th>Status</th>
                <th>Updated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let t of tickets">
                <td>{{ t.subject }}</td>
                <td>{{ t.category }}</td>
                <td>
                  <span class="badge bg-secondary">
                    {{ t.status }}
                  </span>
                </td>
                <td>{{ t.lastUpdatedAt | date:'short' }}</td>
                <td>
                  <a
                    [routerLink]="['/support/tickets', t.id]"
                    class="btn btn-sm btn-outline-primary">
                    View
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <app-footer></app-footer>
  </main>
</div>